<template>
  <div>
    <h4>{{ label }}</h4>
    <div class="category-filter">
      <div class="range-slider">
        <no-ssr>
          <vue-slider
            ref="slider"
            v-model="sliderValue"
            formatter=""
            :min="minValue"
            :max="maxValue"
            :piecewise="true"
          />
        </no-ssr>
        <div class="range-slider-label">
          <div class="minimum">
            {{ minLabel }}
          </div>
          <div class="maximum">
            {{ maxLabel }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixins from './mixins'

let components = {}

if (process.env.SERVER_BUILD !== 'ssr') {
  components['vue-slider'] = () => import('vue-slider-component')
}

export default {
  name: 'generic-filter-range-slider',
  components: components,
  mixins: [
    mixins
  ],
  props: {
    'products': {
      type: Array,
      required: true
    },
    'filter': {
      type: Object,
      required: true
    },
    'value': {
      type: Object,
      required: true
    }
  },
  computed: {
    sliderValue: {
      get: function() {
        return this.value[ this.filter.filterBy ]
      },
      set: function(v) {
        let newValue = Object.assign({}, this.value)
        newValue[ this.filter.filterBy ] = v
        this.$emit('input', newValue)
      }
    },
    minValue: function() {
      return parseInt(this.filter.minValue) || 0
    },
    minLabel: function() {
      return this.filter.minLabel || '0'
    },
    maxValue: function() {
      return parseInt(this.filter.maxValue) || 5
    },
    maxLabel: function() {
      return this.filter.maxLabel || '5'
    }
  }
}
</script>

<style scoped lang="scss">
    .category-filter {
        position: relative;
        min-height: 4em;
        margin: 1em 0;
    }
    .range-slider {
        .range-slider-label {
            position: relative;
            color: var(--main-text-color);

            .minimum {
                text-align: left;
                float: left;
            }
            .maximum {
                text-align: right;
                float: right;
            }
        }
       ::v-deep .vue-slider-component {
          margin-bottom:.5em;
          .vue-slider-dot {
            z-index: 3;
          }
          .vue-slider {
            background-color:var(--main-border-color);
          }
          .vue-slider-dot-handle{
            transition: scale .3s ease-in-out;
            transform: scale(1, 1);
            &:hover{
            transform: scale(1.15, 1.15);
            }
          }
          .vue-slider-process {
                background-color: var(--main-text-color);
            }
            .vue-slider-tooltip {
                display: none;
                background-color: var(--main-primary);
                border-color: var(--main-primary);
            }
        }
    }
</style>
